/* global angular, $, TweenMax, Circ */
angular.module('ua5App.index.about')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('index.about.authors', {
                url: '/authors?:author',
                templateUrl: 'states/index.about/index.about.authors/index.about.authors.html',
                controller: 'AboutAuthorsCtrl',
                controllerAs: 'ctrl',
                resolve: {
                    // Posts Resolve Here //
                    data: ['AboutAuthorsResource', function(AboutAuthorsResource) {
                        return AboutAuthorsResource.get().$promise;
                    }]
                }
            })
        ;
    }])
    .factory('AboutAuthorsResource', ['$resource', '$rootScope', function($resource, $rootScope) {
        var url = 'api/wp-json/pages/authors';
        if ($rootScope.dev) {
            url = url + '?time=' + Date.now();
        }
        return $resource(url, {}, {
            get: {
                method: 'GET',
                cache: true
            }
        });
    }])
    .controller('AboutAuthorsCtrl', ['MetaFactory', 'data', '$timeout', '$stateParams', 'posts', function(MetaFactory, data, $timeout, $stateParams, posts) {
        var self = this;
        var usedAuthors = [];
        self.authors = [];
        angular.forEach(data.acf.authors, function(author) {
            var name = author.name;
            angular.forEach(posts, function(post) {
                var slug = post.slug;
                angular.forEach(post.acf.artwork, function(artwork, index) {
                    if (artwork.commissioned_text_writer === name && usedAuthors.indexOf(name) < 0) { // jshint ignore:line
                        // Add slug and index to each author object
                        self.authors.push({
                            name: name,
                            description: author.description,
                            slug: slug,
                            index: index + 1
                        });
                        // Add to used list to eliminate duplicates
                        usedAuthors.push(name);
                    }
                });
            });
        });
        // Scroll to author if specified in URL
        if ($stateParams.author) {
            $timeout(function() {
                var $$container = $('.state-about__content__wrap');
                var $$element = $('#' + $stateParams.author);
                var containerTop = $$container.offset().top;
                var elementTop = $$element.offset().top;
                TweenMax.to($$container, 0.75, {
                    scrollTop: elementTop - containerTop,
                    ease: Circ.easeOut
                });
            });
        }
        MetaFactory.set({
            title: data.title + ' | Storylines: Contemporary Art at the Guggenheim',
            ogTitle: data.title + ' | Storylines: Contemporary Art at the Guggenheim'
        });
        this.data = data;
    }])
;
